import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const MyAccountGuest = ({ meuBairro }) => {
  const meuBairroAuth = process.env.REACT_APP_COMUNIDADE_IUPP_LOGIN
  const meuBairroSignUp = process.env.REACT_APP_COMUNIDADE_IUPP_SIGNUP

  return meuBairro ? (
    <ul className='list-unstyled'>
      <li>
        <a href={meuBairroAuth}>Entrar</a>
      </li>
      <li>
        <a href={meuBairroSignUp}>Criar uma conta</a>
      </li>
    </ul>
  ) : (
    <ul className='list-unstyled'>
      <li>
        <Link to='/auth/login'>Entrar</Link>
      </li>
      <li>
        <Link to='/auth/login'>Criar uma conta</Link>
      </li>
    </ul>
  )
}

MyAccountGuest.propTypes = {
  meuBairro: PropTypes.bool
}

export default MyAccountGuest



// WEBPACK FOOTER //
// ./src/App/Footer/MyAccountGuest.js